export default /*@ngInject*/ function ($rootScope) {
    $rootScope.helpObject = {
        domain: helpUrl,
        specificArticle: "hc/en-us/articles/",
        home: "hc/en-us"
    };

    $rootScope.archivedNotifications = [];
}